import { render, staticRenderFns } from "./CreateSize.vue?vue&type=template&id=4f8d4d9e&"
import script from "./CreateSize.vue?vue&type=script&lang=js&"
export * from "./CreateSize.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports